// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cLQY","colBig":"styles_colBig__1FP8W","colSmall":"styles_colSmall__2XM6B"};